// @ts-nocheck
/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useIntl } from "react-intl";
import { Column, RowInfo } from "react-table-6";

export const TreeTableHOC = (Component: any) => {

  const wrapper = (componentProps: any) => {

    const TrComponent = (props: any) => {
      const { ri, ...rest } = props;
      if (ri && ri.groupedByPivot) {
        const cell = props.children[ri.level];

        cell.props.style.flex = "unset";
        cell.props.style.width = "100%";
        cell.props.style.maxWidth = "unset";
        cell.props.style.paddingLeft = `${componentProps.treeTableIndent *
          ri.level}px`;
        cell.props.style.backgroundColor = "#EEE";

        return <div {...rest}>{cell}</div>;
      }
      return <Component.defaultProps.TrComponent {...rest} />;
    };

    const getTrProps = (state: any, ri: RowInfo, ci: Column, instance: any) => {
      if(componentProps.getTrProps){
        return { ri, ...componentProps.getTrProps(state, ri, ci, instance) };
      }
      if (ri){
        return { ri };
      }
      return {}
    };

    const { columns, ...rest } = componentProps;
    const extra = {
      columns: columns.map(col => {
        let column = col;
        if (rest.pivotBy && rest.pivotBy.includes(col.accessor)) {
          column = {
            accessor: col.accessor,
            width: `${componentProps.treeTableIndent}px`,
            show: false,
            Header: ""
          };
        }
        return column;
      }),
      TrComponent,
      getTrProps,
    };

    return <Component {...rest} {...extra} />;
  };
  wrapper.displayName = "RTTreeTable";
  wrapper.defaultProps = {
    treeTableRowBackground: "#EEE",
    treeTableIndent: 10
  };
  return wrapper;
};

export default TreeTableHOC;